/**
 * Created by psivanappans on 10/03/2022
 * File: SubNet
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Input } from '@panwds/react-form-legacy'
import { useFormContext } from 'react-hook-form'
import { OBJECT } from '../../../../../common/utils/Utils'
import { URL_VALIDATIONS } from '../../../constants/SubscriptionConstant'
import { Validation } from '../../../validation/Validation'
const SubNet = (props) => {
  const { entitlement,
    existedInstance,
    loading,
    subnetName,
    domainPostFix,
    selectedTreeNode,
    cspAccount } = props
  const { trigger } = useFormContext()

  return (
    <div className="tw-flex" style={{ flex: 2 }}>
      <Input
        disabled={OBJECT.hasObject(existedInstance) || loading}
        showLabel={false}
        style={{ textTransform: 'lowercase' }}
        placeholder="URL Subnet"
        label= 'Subdomain'
        addClassName="tw-w-64"
        name={subnetName}
        register={{
          validate: Validation({
            appId: entitlement?.app_id, domainPostFix, validationRules:
              { validation_required: !OBJECT.hasObject(existedInstance) }, selectedTreeNode, cspAccount
          }),
          onChange: ((e) => {
            trigger(subnetName)
          }),
        }}
      />
      <div className="tw-pl-1 tw-pt-2">{domainPostFix[entitlement?.app_id]}</div>
    </div>
  )
}

SubNet.propTypes = {}

export default SubNet
